"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const actionContext_1 = require("../contexts/actionContext");
exports.headerColumnFormatter = (column, colIndex, components) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        column.text,
        components.sortElement,
        react_1.default.createElement(ResizerComponent, null)));
};
const ResizerComponent = () => {
    const { cellResizer } = react_1.useContext(actionContext_1.ActionContextCreator);
    return react_1.default.createElement("span", { className: "resize-handle", onMouseDown: cellResizer });
};
//# sourceMappingURL=HeaderColumnFormatter.js.map